import { accessibilityActionTypes } from '@constants/actionTypes/accessibilityActionTypes';

export const INITIAL_STATE = {
    isEnlargedFontEnabled: false
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case accessibilityActionTypes.SET_ENLARGED_FONT_ENABLED:
            return {
                ...INITIAL_STATE,
                isEnlargedFontEnabled: action.isEnlargedFontEnabled
            };
        default:
            return state;
    }

};